export const FINANCE_STEP_COUNT = 1000;
export const INTEREST_ANNUALLY_DIVIDER = 12;

export const FORM_FIELDS = {
    DOB: 'dob'
};

export const LEAD_GEN_FORM = 'cf_lead_form';
